import { render, staticRenderFns } from "./ExercisesList.vue?vue&type=template&id=d4071552&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ExercisesList.vue?vue&type=style&index=0&id=d4071552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4071552",
  null
  
)

export default component.exports